import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { AuthGuard } from './guards/AuthGuard'
import { LoginPage } from '@/pages/LoginPage'
import { SignupPage } from '@/pages/SignupPage'
import { VerifyEmailPage } from '@/pages/VerifyEmailPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { MenuPage } from '@/pages/MenuPage'
import { MenuItemDetailPage } from '@/pages/MenuItemDetailPage'
import { RecipesPage } from '@/pages/RecipesPage'
import { IngredientsPage } from '@/pages/IngredientsPage'
import { CateringPage } from '@/pages/CateringPage'
import { CateringPricingPage } from '@/pages/CateringPricingPage'
import { OperationsPage } from '@/pages/OperationsPage'
import { SalesPage } from '@/pages/SalesPage'
import { MarketingPage } from '@/pages/MarketingPage'
import { TeamPage } from '@/pages/TeamPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { StoreSupplyPage } from '@/pages/StoreSupplyPage'
import { BuyersPage } from '@/pages/BuyersPage'
import { InvoicesPage } from '@/pages/InvoicesPage'
import { PurchaseOrdersPage } from '@/pages/PurchaseOrdersPage'
import { StockUpdatePage } from '@/pages/StockUpdatePage'
import { SuppliersPage } from '@/pages/SuppliersPage'
import { CateringQuotePage } from '@/pages/CateringQuotePage'
import { StorefrontPage } from '@/pages/StorefrontPage'
import { WebOrdersPage } from '@/pages/WebOrdersPage'

export const router = createBrowserRouter([
  { path: '/login',        element: <LoginPage /> },
  { path: '/signup',       element: <SignupPage /> },
  { path: '/verify-email', element: <VerifyEmailPage /> },
  { path: '/q/:orderNumber', element: <CateringQuotePage /> },
  { path: '/store/:slug',    element: <StorefrontPage /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: 'dashboard',  element: <DashboardPage /> },
          { path: 'products', children: [
            { index: true,           element: <MenuPage /> },
            { path: 'items/new',     element: <MenuItemDetailPage /> },
            { path: 'items/:id',     element: <MenuItemDetailPage /> },
            { path: 'ingredients',   element: <IngredientsPage /> },
            { path: 'stock',         element: <StockUpdatePage /> },
            { path: 'recipes',       element: <RecipesPage /> },
          ]},
          { path: 'catering', children: [
            { index: true,   element: <CateringPage /> },
            { path: 'pricing', element: <CateringPricingPage /> },
          ]},
          { path: 'web-orders',  element: <WebOrdersPage /> },
          { path: 'inventory',  element: <IngredientsPage /> },
          { path: 'operations/*',element: <OperationsPage /> },
          { path: 'sales/*',    element: <SalesPage /> },
          { path: 'marketing/*',element: <MarketingPage /> },
          { path: 'store-supply',     element: <StoreSupplyPage /> },
          { path: 'buyers',           element: <BuyersPage /> },
          { path: 'invoices',         element: <InvoicesPage /> },
          { path: 'purchase-orders',  element: <PurchaseOrdersPage /> },
          { path: 'suppliers',         element: <SuppliersPage /> },
          { path: 'team',         element: <TeamPage /> },
          { path: 'settings/*',   element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
])
